import { ReactNode } from 'react';
import { Box } from '@mui/material';

export default function PlanDetailsContainer({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      {children}
    </Box>
  );
}
